module.exports = __webpack_public_path__ + "static/mailgun-domain-26859f416ee09440778f94617ce4ca29.png";